import { useSelector } from 'react-redux';

function AccessControl({ pageId, action, children }) {
  const {
    user: { permissions, isSuperUser },
  } = useSelector((state) => state.auth);

  if (isSuperUser) {
    return children;
  }

  if (
    permissions[pageId] !== undefined &&
    permissions[pageId][action] === true
  ) {
    return children;
  }

  return null;
}

export { AccessControl };
